import {
  isValueNotEmptyMessage,
  isValueRelatedArrayNotDuplicate,
} from 'src/components/pages/PipelinesPages/utils/validators'

export const pipelineNameValidators = [
  {
    validator: isValueNotEmptyMessage,
    message: 'Pipeline name should not be empty',
  },
  {
    validator: isValueRelatedArrayNotDuplicate,
    message: 'Pipeline name should be unique within the parent',
  },
]
